"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _material = require("@mui/material");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["type"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var StyledText = (0, _styledComponents.default)(_material.Typography)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\nfont-family: Roboto;\nfont-weight: normal;\nfont-stretch: normal;\nfont-style: normal;\nline-height: normal;\ncolor: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary.main;
});
var H1Text = (0, _styledComponents.default)(StyledText)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 46px;\nletter-spacing: -0.23px;\n"])));
var H2Text = (0, _styledComponents.default)(StyledText)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 26px;\nletter-spacing: normal;\n"])));
var H3Text = (0, _styledComponents.default)(StyledText)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 22px;\nletter-spacing: normal;\n"])));
var H4Text = (0, _styledComponents.default)(StyledText)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 15px;\nline-height: 1.33;\nletter-spacing: normal;\n"])));
var H5Text = (0, _styledComponents.default)(StyledText)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 12px;\nline-height: 1.17;\nletter-spacing: normal;\n"])));
var H6Text = (0, _styledComponents.default)(StyledText)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\nfont-size: 8px;\nline-height: 1.75;\nletter-spacing: normal;\n"])));
var SpanText = (0, _styledComponents.default)(H4Text)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\nfont-weight: bold;\n"])));
var PText = (0, _styledComponents.default)(H4Text)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\nopacity: 0.7;\n"])));
var LabelText = (0, _styledComponents.default)(_material.InputLabel)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\nopacity: 0.7;\nfont-size: 12px;\nfont-weight: normal;\nfont-stretch: normal;\nfont-style: normal;\nline-height: 1.17;\nletter-spacing: normal;\ncolor: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.secondary.main;
});

var Text = function Text(_ref3) {
  var type = _ref3.type,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);

  switch (type) {
    case 'h1':
      return /*#__PURE__*/_react.default.createElement(H1Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'h2':
      return /*#__PURE__*/_react.default.createElement(H2Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'h3':
      return /*#__PURE__*/_react.default.createElement(H3Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'h4':
      return /*#__PURE__*/_react.default.createElement(H4Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'h5':
      return /*#__PURE__*/_react.default.createElement(H5Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'h6':
      return /*#__PURE__*/_react.default.createElement(H6Text, Object.assign({}, rest, {
        variant: type
      }));

    case 'span':
      return /*#__PURE__*/_react.default.createElement(SpanText, Object.assign({}, rest, {
        variant: "caption"
      }));

    case 'p':
      return /*#__PURE__*/_react.default.createElement(PText, Object.assign({}, rest, {
        variant: "body1"
      }));

    case 'label':
      return /*#__PURE__*/_react.default.createElement(LabelText, rest);

    default:
      return /*#__PURE__*/_react.default.createElement(StyledText, rest);
  }
};

Text.defaultProps = {
  type: null
};
var _default = Text;
exports.default = _default;